import { gql } from '@apollo/client';

export const CANCEL_INCIDENT = gql`
mutation cancelIncident($input: CancelIncidentInput!) {
  cancelIncident(input: $input) {
    errors
    incidentId
    clientMutationId
  }
}
`

// Example input
// {
//   "input": {
//     "incidentId": ID!,
//    "officerId": ID!,
//     "cancel": Boolean!,
//     "clientMutationId": String,
//   }
// }